// extracted by mini-css-extract-plugin
module.exports = {"Share":"Share_Share__0pYth","ShareTxt":"Share_ShareTxt__DodYy","Tooltip":"Share_Tooltip__yeJu3","tooltip":"Share_tooltip__BziV2"};